<template>
  <Form ref="loginForm" :model="form" :rules="rules" @keydown.enter.native="handleSubmit">
    <div class="container">
      <ul class="banner_log_on_list row">
        <li class="col-lg-3 col-sm-6 col-xs-6 wow fadeInDown" data-wow-duration="0.4s" data-wow-delay="0.3s">
          <FormItem prop="userName">
            <input class="font-text" v-model="form.userName" value placeholder="请输入账号" />
            </input>
          </FormItem>
        </li>
        <li class="col-lg-3 col-sm-6 col-xs-6 wow fadeInDown" data-wow-duration="0.8s" data-wow-delay="0.3s">
          <FormItem prop="password">
            <input class="font-text" type="password" v-model="form.password" placeholder="请输入密码">
            </input>
          </FormItem>
        </li>
        <li class="col-lg-3 col-sm-6 col-xs-6 wow fadeInDown " data-wow-duration="0.8s" data-wow-delay="0.3s">
          <FormItem prop="verifyCode">
            <input class="font-text"  v-model="form.verifyCode" placeholder="请输入验证码">
            </input>
          </FormItem>
        </li>
        <li class="verifyCodeItemCss" data-wow-duration="0.8s" data-wow-delay="0.3s">
            <!-- <el-input class="verify_css" placeholder="请输入4位验证码" v-model="form.verifyCode" @keyup.enter.native="submitForm('ruleForm')"></el-input> -->
            <div id="v_container"></div>
        </li>
        <li class="wow fadeInDown" data-wow-duration="1.2s" data-wow-delay="0.3s">
          <FormItem>
            <input class="button font-text" @click="handleSubmit" type="button" value="登录平台" placeholder="">
            <!-- <input class="button" @click="WXSubmit" type="button" value="微信登录" placeholder=""> -->
            <!-- <Button @click="handleSubmit"  type="primary" long placeholder>登录进入实验</Button> -->
          </FormItem>
        </li>
      </ul>

    </div>
  </Form>
</template>
<script>
import axios from "@/libs/api.request";
import "../../../static/css/style.css";
import { GVerify } from '../../../static/js/verifyCode';
export default {
  name: "LoginForm",
  props: {
    userNameRules: {
      type: Array,
      default: () => {
        return [{ required: true, message: "账号不能为空", trigger: "blur" }];
      }
    },
    passwordRules: {
      type: Array,
      default: () => {
        return [{ required: true, message: "密码不能为空", trigger: "blur" }];
      }
    },
    verifyRules: {
      type: Array,
      default: () => {
        return [{ required: true, message: "验证码不能为空", trigger: "blur" }];
      }
    },
  },
  data() {
    return {
      verifyCode:null,
      form: {
        userName: "",
        password: "",
        verifyCode:"",
      }
    };
  },
  computed: {
    rules() {
      return {
        userName: this.userNameRules,
        password: this.passwordRules,
        verifyCode: this.verifyRules
      };
    }
  },
  mounted () {
    this.verifyCode = new GVerify('v_container')
  },
  methods: {
    handleSubmit() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          var verifyCode = this.form.verifyCode
          var verifyFlag = this.verifyCode.validate(verifyCode)
          if(!verifyFlag){
            this.$Modal.error({
                title: "提示",
                content: "验证码输入错误，请重新输入",
              });
            return
          }
          this.$emit("on-success-valid", {
            userName: this.form.userName,
            password: this.form.password,
          });
        }
      });
    },
    WXSubmit() {

      let APPID = "这个是申请的APPID";
      let REDIRECT_URI = encodeURIComponent("这个是在微信开发工具网页端的地方填写的地址 - 授权回调域 中 后面可添加");
      this.urltest = `https://open.weixin.qq.com/connect/qrconnect?appid=${APPID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=snsapi_login&state=3d6be0a4035d839573b04816624a415e#wechat_redirect`;
      var obj = new WxLogin({
        self_redirect: false,
        id: "login_container",
        appid: APPID,
        scope: "snsapi_login",
        redirect_uri: REDIRECT_URI,
        state: localStorage.getItem("authToken"),
        style: "black",
        href:
          "data:text/css;base64,LmltcG93ZXJCb3ggLm5vcm1hbFBhbmVse21hcmdpbi10b3A6IDE1cHg7fQouaW1wb3dlckJveCAucXJjb2RlIHt3aWR0aDogMjMwcHg7Ym9yZGVyLWNvbG9yOiNDNUUxRkY7fQouaW1wb3dlckJveCAudGl0bGUge2Rpc3BsYXk6IG5vbmU7fQ==",
      });
      var posturl = this.config.baseUrl.pro + "/login/OpenWxOpenId";
      axios
        .request({
          url: posturl,
          method: "post",
          data: { encode: obj },
        })
        .then((resp) => {
          console.log(resp);
        })
        .catch((err) => {
          console.log(err);
          return { code: -1, message: "登录失败", token: null, data: "" };
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/loginForm/loginForm.vue